import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Store, createSelector } from '@ngrx/store';
import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { AddressAutocompleteComponent } from '../../../../../address-autocomplete/address-autocomplete.component';
import { ColorSchemeService } from '../../../../../color-scheme.service';
import { JOB_LOCATION_TYPES_V3, locationNameMap } from '../../../../../global.constants';
import { createConfigSelector } from '../../../../../state/branding.store';
import { generateUUID } from '../../../../../utilities/state.util';
import { EventInfoLocationJobsV2 } from '../../../../job-events-helpers';
import { JobsV2EventLocation, jobToolFeature, selectJob, selectPotentialEventLocations } from '../../../../job-tool.reducer';

import { selectFormDisabled } from '../timeline-book-event.component';
import { eventScheduleSelectors, selectEventItineraryLocations } from '../timeline-book-event.selectors';

import { EventItineraryActions } from './event-itinerary.actions';


import { eventItineraryFeature } from './event-itinerary.feature';
import { selectCanSaveLocations, selectLocationsOrderChanged } from './event-itinerary.selectors';

@Component({
    selector: 'app-event-itinerary',
    standalone: true,
    imports: [
        CommonModule,
        FreyaCommonModule,
        SharedModule,
        ReactiveFormsModule,
        DragDropModule,
        AddressAutocompleteComponent,
    ],
    templateUrl: './event-itinerary.component.html',
    styleUrls: ['./event-itinerary.component.scss'],
})
export class EventItineraryComponent  {

    public viewModel$ = this.store.select(createSelector({
        showDockTravelTimeCheckbox: createConfigSelector('CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX'),
        includeDockTravel: createSelector(eventItineraryFeature.selectEventItinerary, ({ includeDockTravel }) => includeDockTravel),
        dockTravelTimeDisabled: selectFormDisabled,
        hasLocationsOrderChanged: createSelector(
            selectCanSaveLocations,
            selectLocationsOrderChanged,
            (canSaveEvent, hasChanges) => {
                return { canSaveEvent, hasChanges };
            }
        ),
        isEventUpdating: jobToolFeature.selectEventsMutating,
        eventItineraryLocations: selectEventItineraryLocations,
        eventHasNoLocations: eventScheduleSelectors.selectEventItineraryNoLocations,
        potentialEventLocations: createSelector(selectPotentialEventLocations, (potentialEventLocations) => {
            return JOB_LOCATION_TYPES_V3
                .filter((locationType) => locationType !== 'dock')
                .map((locationType) => {

                    const existingLocation = potentialEventLocations.find((l) => l.type === locationType);

                    if (existingLocation) {
                        return existingLocation;
                    }

                    const id = generateUUID();

                    const placeholderLocation: JobsV2EventLocation = {
                        id,
                        locationId: id,
                        type: locationType,
                        addressLabel: locationType,
                        address: '',
                        order: 0,
                        estimatedTimeAtLocation: 0,
                        totalTravelTimeToNextLocation: 0,
                        ignoreInDuration: false,
                    }

                    return placeholderLocation;
                });
        }),
        timerMessage: createSelector(
            eventItineraryFeature.selectEventItinerary,
            ({ saveEventCountdown, saveEventCountdownActive }) => {
                if (!saveEventCountdownActive) { return; }
                return `Calculating in ${ saveEventCountdown } seconds`;
            }
        ),
        isAddStopButtonDisabled: createSelector(
            selectEventItineraryLocations,
            selectJob,
            (locations, job) => {
                if (!locations || !job) {
                    return {isDisabled: true, reason: 'No event selected'};
                }

                if (locations?.length >= 10) {
                    return {isDisabled: true, reason: 'Maximum of 10 stops reached'};
                }
            }
        ),
    }));

    public actions = EventItineraryActions;
    public locationNameMap = locationNameMap;

    constructor(
        public store: Store,
        public colorScheme: ColorSchemeService,
    ) {}

    trackByLocationName(index: number, location: EventInfoLocationJobsV2) {
        return location?.id || index;
    }

}
